import { lazy } from 'react';

import type { Location } from '@core/Router/locations';

import { DATA_ISOLATION_NAV_LINK } from './dataIsolationRoutes';

const DataIsolationPage = lazy(() =>
    import(/* webpackChunkName: "data-isolation" */ '../ui/DataIsolationPage').then(m => ({
        default: m.DataIsolationPage,
    })),
);

export const dataIsolationLocations: Location[] = [
    {
        url: DATA_ISOLATION_NAV_LINK,
        Component: DataIsolationPage,
    },
];
